import React from "react";

export interface SolutionChecklistItem {
    title: string;
    description: string;
}

interface SolutionChecklistProps {
    items: SolutionChecklistItem[];
}

export default function SolutionChecklist({ items }: SolutionChecklistProps) {
    return (
        <ul className="solution-checklist">
            {items.map((item) => (
                <li key={item.title} className="solution-checklist-item">
                    <span className="solution-check" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                            <path d="M5 12.5 10 17.5 19 6.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <div>
                        <h3 className="solution-check-title">{item.title}</h3>
                        <p className="solution-check-desc">{item.description}</p>
                    </div>
                </li>
            ))}
        </ul>
    );
}
